module.exports = "/_next/static/resources/array-c5fba7ea53463c1ae946fea2ef16e9d3.webp";